<app-uni-page [parent]="this" pageTitle="Purchases: Backorder Management {{ getTitle() }}" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="flex flex-col h-full overflow-hidden">
    <div class="flex justify-between items-center mr-4 my-2 shrink-0">
      <div class="flex items-center gap-2">
        <p-confirmpopup key="uniqueKey">
          <ng-template #content let-message>
            <div class="card flex justify-center">
              <p-inputMask mask="99/99/9999" [(ngModel)]="updateDate" placeholder="MM/DD/YYYY"></p-inputMask>
            </div>
            <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700 p-4 mb-4 pb-0">
              <i [class]="message.icon" class="!text-6xl text-primary-500"></i>
              <p>{{ message.message }}</p>
            </div>
          </ng-template>
        </p-confirmpopup>
        <p-button [disabled]="isApplyDisabled()" (click)="onUpdate($event)" label="Update {{ selectedCount }} Manufacturer Ship Dates" size="small" />
      </div>
    </div>

    <app-ag-grid [gridOptions]="pobGridOptions" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button *ngIf="!this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-check" (click)="saveChanges()">
      <span>Save</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-undo" (click)="cancelChanges()">
      <span>Undo</span>
    </button>
  </div>
</ng-template>
